// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createAsyncAction } from 'typesafe-actions';

import { Chapter } from '../../../types/Model';
import { Progress } from '../../../types/Model';

export interface OnlineCourseChaptersRequestPayload {
  id: number;
  preventLoading?: boolean;
}
export interface OnlineCourseChaptersSuccessPayload {
  id: number;
  chapters: Chapter[];
  progress: Progress[];
}

export interface OnlineCourseChaptersFailPayload {
  error: Error;
}

const getOnlineCourseContentsDataActions = createAsyncAction(
  'elearning/GET_ONLINE_COURSE_CHAPTERS_DATA',
  'elearning/GET_ONLINE_COURSE_CHAPTERS_DATA_SUCCESS',
  'elearning/GET_ONLINE_COURSE_CHAPTERS_DATA_FAIL'
)<
  OnlineCourseChaptersRequestPayload,
  OnlineCourseChaptersSuccessPayload,
  OnlineCourseChaptersFailPayload
>();

export { getOnlineCourseContentsDataActions as default }
